<template>
    <v-card>
        <v-card-title class="bg-title-card">
            <span class="white--text headline" v-text="tituloFormulario"></span>
        </v-card-title>
        <v-container>
            <v-form ref="form">
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="seleccionado.idAseguradora"
                            :rules="requeridoRegla" :items="listaGeneral.aseguradora" item-text="aseguradora"
                            item-value="idAseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="seleccionado.idSeguro"
                            :rules="requeridoRegla" :items="listaGeneral.seguro" item-text="seguro"
                            item-value="idSeguro" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Cobertura *" color="textbox" v-model="seleccionado.cobertura"
                            :rules="_.concat(requeridoRegla,soloLetrasRegla(4,seleccionado.cobertura,300))" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Siglas *" color="textbox" v-model="seleccionado.siglas"
                            :rules="_.concat(requeridoRegla,soloLetrasRegla(3,seleccionado.siglas,10))" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-autocomplete label="Estado *" color="textbox" v-model="seleccionado.idEstado"
                            :rules="requeridoRegla" :items="listaEstado" item-text="nombre_estado"
                            item-value="id_estado" outlined dense />
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <v-btn outlined dense rounded class="mr-1" color="danger" @click="cerrarFormulario(), $refs.form.resetValidation()">
                            Cancelar</v-btn>
                        <v-btn rounded dark color="primary" @click="guardar()">Guardar</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'ModalCoberturaComponent',
        data: () => ({
            date: new Date().toISOString().substr(0, 10),
            menu: false,
        }),
        methods: {
            guardar() {
                if (this.$refs.form.validate()) {
                    this.insertarActualizar((this.seleccionado.idCobertura == 0) ? "I" : 'U');
                    this.cerrarFormulario();
                    this.$refs.form.resetValidation()
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
        },
        props: ['seleccionado', 'tituloFormulario', 'listaGeneral', 'listaEstado'],
        inject: ['insertarActualizar', 'cerrarFormulario'],
    }
</script>